const getState = state => state.room

export const getCustomRoomName = state => getState(state).customRoomName
export const getPersonalRoom = state => getState(state).personalRoom
export const getPersonalRoomName = state => getPersonalRoom(state).name
export const getPersonalRoomUrl = state => getPersonalRoom(state).url
export const getPersonalRoomPassword = state => getPersonalRoom(state).password
